import { Form, Input } from 'antd';
import { useState } from 'react';
import { apiClient, apiErrorMessage } from '../../../utils';
import { FourM } from '../../../models/index';
import { ConfirmGroupButton } from '../../../elements/confim-group-button';

export function FourMEditPage(props: { fourM?: FourM; onSaved: (fourM?: FourM) => void; onCancel: () => void }) {
  const [loading, setLoading] = useState(false);

  const onFinish = (values: any) => {
    setLoading(true);
    if (!props.fourM) {
      apiClient
        .post('four-ms', values)
        .then(() => {
          props.onSaved();
        })
        .catch((reason: any) => {
          apiErrorMessage(reason);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      apiClient
        .put(`four-ms/${props.fourM?.id}`, values)
        .then((response: any) => {
          props.onSaved(response.data);
        })
        .catch((reason: any) => {
          apiErrorMessage(reason);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  return (
    <Form layout="vertical" name="basic" onFinish={onFinish} initialValues={props.fourM}>
      <Form.Item
        label="İsim"
        name="name"
        rules={[
          { required: true, message: 'Zorunlu alan' },
          { max: 20, message: 'En fazla 2o karakter' },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item>
        <ConfirmGroupButton onCancel={props.onCancel} loading={loading} />
      </Form.Item>
    </Form>
  );
}
